import { useState } from "react";

export const usePopoverControls = () => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "download" : undefined;

    const handleToggle = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return {
        anchorEl,
        open,
        id,
        handleClose,
        handleToggle
    };
};
